import net from "App/net";

var Client = function() {

};

Client.prototype.getAll = function() {
    return net.get("/CargoUnits");
};

export default new Client();